export const bannerType=[{
    key:"Mobile",
    value:'1'
},
{
    key:"DeskTop",
    value:"2"
}]

export const topEnum='1'
export const activeEnum='1'
export const showBannerEnum=[{
    key:"Top",
    value:'1'
},
{
    key:"Middle",
    value:'2'
},
{
    key:"Lower",
    value:'3' 
}]

export const finishingEnum=[
    {
        key:"White Rhodium Silver",
        value:"White Rhodium Silver",
    },
    {
        key:"14K Rose Gold Overlay",
        value:"14K Rose Gold Overlay",
    },
    {
        key:"14K Yellow Gold Overlay",
        value:"14K Yellow Gold Overlay",
    },
    {
        key:"14K Solid Rose Gold",
        value:"14K Solid Rose Gold",
    },
    {
        key:"14K Solid Yellow Gold",
        value:"14K Solid Yellow Gold",
    },
    {
        key:"14K Solid White Gold",
        value:"14K Solid White Gold",
    },
]

export const statusEnum=[
    {
        key:"Pending",
        value:"Pending"
    },
    {
        key:"Processing",
        value:"Processing"
    },
    {
        key:"Shipping",
        value:"Shipping"
    },
    {
        key:"Delivered",
        value:"Delivered"
    }
]

export const PendingEnum='Pending'
export const ProcessingEnum='Processing'
export const ShippingEnum='Shipping'
export const DeliveredEnum='Delivered'

export const socialMediaEnum=[
    {
        key:"FaceBook",
        value:"bi bi-facebook"
    },
    {
        key:"Twitter",
        value:"bi bi-twitter"
    },
    {
        key:"Instagram",
        value:"bi bi-instagram"
    },
    {
        key:"Youtube",
        value:"bi bi-youtube"
    },
    {
        key:"Skype",
        value:"bi bi-skype"
    },
    {
        key:"Linkedin",
        value:"bi bi-linkedin"
    },
]